import { IAttachedQuickSignDocument } from '@shared/models/proto/base/chat'
import { IMessage } from '@shared/models/proto/base/messages'

export const updateQuickSignInMessage = (
  messageArray: Array<IMessage>,
  newValue: Partial<IAttachedQuickSignDocument>
): Array<IMessage> =>
  messageArray.map((message: IMessage) => {
    const updatedAttachments = message.attachments.map((attachment) => {
      if (
        attachment.payload.case === 'quickSignDocument' &&
        attachment.payload.value.id === newValue.id
      ) {
        // Update the value for the matching attachment
        return {
          ...attachment,
          payload: {
            case: 'quickSignDocument',
            value: { ...attachment.payload.value, ...newValue },
          },
        }
      }

      return attachment
    })

    // Return the updated message with the modified attachments array
    return { ...message, attachments: updatedAttachments } as IMessage
  })
